import { handleRequest } from "./base";

// UserRepo is used to retrieve auth
const UserRepo = {
  authURL: () => {
    return handleRequest({
      method: 'get',
      url: '/auth'
    }, false)
  },

  authConfirm: (val) => {
    return handleRequest({
      method: 'get',
      url: '/auth/confirm',
      params: val,
    }, false)
  },

  logout: () => {
    return handleRequest({
      method: 'get',
      url: '/auth/logout'
    }, false)
  },

  all: () => {
    return handleRequest({
      method: 'get',
      url: '/api/users'
    })
  },

  revokeKey: email => {
    return handleRequest({
      method: 'delete',
      url: `/api/users/${email}/key`,
    })
  },
};

export default UserRepo;
